import { FeatureCollection } from 'geojson'
import { FC } from 'react'
import { useDisplay } from '~map-preview/states/hexagons'
import { Hexagon2DLayer } from './2D'
import { Hexagon3DLayer } from './3D'

type HexagonLayerProps = {
  geojson: FeatureCollection
  resolution3D: number
}

const HexagonLayer: FC<HexagonLayerProps> = (props) => {
  const { geojson, resolution3D } = props

  const display = useDisplay()

  return (
    <>
      {display === '2D' && <Hexagon2DLayer geojson={geojson} />}
      {display === '3D' && (
        <Hexagon3DLayer
          geojson={geojson}
          resolution3D={resolution3D}
        />
      )}
    </>
  )
}

export { HexagonLayer }
